import numberWithSpaces from 'helpers/number-format';

export default function getCountMax(count: number, maxCount = 10000): string {
    return count >= maxCount ? `Ponad ${numberWithSpaces(maxCount)}` : numberWithSpaces(count);
}
